// Cart Sidebar Functions
// Separado do theme.js para melhor organização
// Funções são chamadas pelo theme.js quando necessário

(function() {
    'use strict';

    const $body = document.body;

    // Helper to access halo functions
    function getHalo() {
        return window.halo || {};
    }

    // Define cartSidebar functions
    const cartSidebar = {
        initQuickCart: function () {
            if (window.quick_cart.show) {
                if (window.quick_cart.type == 'popup') {
                    // halo.initDropdownCart();
                } else {
                    cartSidebar.initSidebarCart();
                }
            }

            cartSidebar.initEventQuickCart();
        },

        initEventQuickCart: function () {
            cartSidebar.removeItemQuickCart();
            cartSidebar.updateQuantityItemQuickCart();
            cartSidebar.editQuickCart();
        },

        productCollectionCartSlider: function () {
            // Use Swiper module
            if (typeof window.initAllProductCollectionCartSliders === 'function') {
                window.initAllProductCollectionCartSliders();
            }
        },

        updatePopupCart: function (cart, layout, variantId) {
            var item = cart.items.filter(item => item.id == variantId)[0];
            if (!item) return;

            const popup = document.querySelector('[data-add-to-cart-popup]');
            if (!popup) return;

            const product = popup.querySelector('.product-added');
            if (!product) return;

            const productTitle = product.querySelector('.product-title');
            const productImage = product.querySelector('.product-image');
            const title = item.title || item.product_title;
            const image = item.featured_image;
            const img = '<img src="' + image.url + '" alt="' + image.alt + '" title="' + image.alt + '"/>';

            if (productImage) {
                productImage.setAttribute('href', item.url);
                productImage.innerHTML = img;
            }

            if (productTitle) {
                const titleEl = productTitle.querySelector('.title');
                if (titleEl) {
                    titleEl.setAttribute('href', item.url);
                    titleEl.innerHTML = '';
                    titleEl.appendChild(document.createTextNode(title));
                }
            }

            Shopify.getCart((cartTotal) => {
                document.querySelectorAll('[data-cart-count]').forEach(el => {
                    el.textContent = cartTotal.item_count;
                });
            });
        },

        initSidebarCart: function () {
            // Encontrar TODOS os elementos do carrinho (pode haver um no mobile e outro no desktop)
            const cartIcons = document.querySelectorAll('[data-cart-sidebar]');

            if (!cartIcons || cartIcons.length === 0) return;

            // Função para anexar listeners a um elemento
            const attachListeners = (cartIcon) => {
                // Verificar se já foi inicializado
                if (cartIcon.hasAttribute('data-cart-sidebar-initialized')) return;
                cartIcon.setAttribute('data-cart-sidebar-initialized', 'true');

                let checkInitSideBarCart = true;
                cartIcon.addEventListener('click', () => {
                    if (!checkInitSideBarCart) return;
                    checkInitSideBarCart = false;
                    Shopify.getCart((cart) => {
                        cartSidebar.updateSidebarCart(cart);
                    });
                    if (document.body.classList.contains('cursor-fixed__show')) {
                        window.sharedFunctionsAnimation.onEnterButton();
                        window.sharedFunctionsAnimation.onLeaveButton();
                    }
                });

                if (document.body.classList.contains('template-cart')) {
                    cartIcon.addEventListener('click', (event) => {
                        event.preventDefault();
                        event.stopPropagation();

                        window.scrollTo({
                            top: 0,
                            behavior: 'smooth'
                        });
                    });
                    const halo = getHalo();
                    if (halo.checkNeedToConvertCurrency && halo.checkNeedToConvertCurrency()) {
                        const currencyEl = document.querySelector('#currencies .active');
                        const currencyCode = currencyEl ? currencyEl.getAttribute('data-currency') : null;
                        if (currencyCode) {
                            Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                        }
                    }
                } else {
                    cartIcon.addEventListener('click', (event) => {
                        event.preventDefault();
                        event.stopPropagation();

                        if (document.body.classList.contains('menu_open')) {
                            document.body.classList.remove('menu_open');
                        }

                        document.body.classList.add('cart-sidebar-show');
                    });
                }
            };

            // Anexar listeners a todos os elementos encontrados
            cartIcons.forEach(attachListeners);

            document.addEventListener('click', (event) => {
                const closeBtn = event.target.closest('[data-close-cart-sidebar]');
                if (closeBtn) {
                    event.preventDefault();
                    event.stopPropagation();
                    if (document.body.classList.contains('cart-sidebar-show')) {
                        document.body.classList.remove('cart-sidebar-show');
                    }
                }
            });

            document.addEventListener('click', (event) => {
                if (event.target.classList.contains('background-overlay') || event.target.closest('.background-overlay')) {
                    if (document.body.classList.contains('cart-sidebar-show') &&
                        !document.body.classList.contains('quickshop-popup-show') &&
                        !document.body.classList.contains('quick_shop_popup_mobile') &&
                        !document.body.classList.contains('edit-cart-show') &&
                        !document.body.classList.contains('term-condition-show') &&
                        !document.body.classList.contains('has-warning')) {
                        const target = event.target;
                        if (!target.closest('#halo-cart-sidebar') &&
                            !target.closest('[data-cart-sidebar]') &&
                            !target.closest('[data-edit-cart-popup]') &&
                            !target.closest('[data-warning-popup]') &&
                            !target.closest('[data-term-condition-popup]')) {
                            document.body.classList.remove('cart-sidebar-show');
                        }
                    }
                }
            });
        },

        updateSidebarCart: function (cart) {
            // PG: renderizar NAO escreve no carrinho. O merge de linhas divididas
            // (brinde) e so de exibicao, feito no Liquid em halo-side-cart.liquid.
            // O antigo pgMergeDuplicateLineItems gravava a cada abertura da gaveta e
            // agrupava so por variant_id, fundindo linhas com propriedades distintas.
            // Escritas ficam todas no motor de snippets/halo-cart-sidebar.liquid.
            if (cart && Object.keys(cart).length > 0) {
                cartSidebar._doRenderSidebarCart(cart);
            }
        },

        _doRenderSidebarCart: function (cart) {
            if (!cart || !Object.keys(cart).length) return;
                const cartDropdown = document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
                if (!cartDropdown) return;

                const cartLoading = '<div class="loading-overlay loading-overlay--custom">\
                        <div class="loading-overlay__spinner">\
                            <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">\
                                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>\
                            </svg>\
                        </div>\
                    </div>';
                const loadingClass = 'is-loading';

                cartDropdown.classList.add(loadingClass);
                cartDropdown.insertAdjacentHTML('afterbegin', cartLoading);

                fetch(window.routes.root + '/cart?view=ajax_side_cart', {
                    method: 'GET',
                    cache: 'no-store'
                })
                .then(response => response.text())
                .then(data => {
                    cartDropdown.classList.remove(loadingClass);
                    cartDropdown.innerHTML = data;

                    // PG: a remocao de linhas combinadas passou a ser tratada pelo motor
                    // em snippets/halo-cart-sidebar.liquid (por chave, na fila serial).
                    // O handler que existia aqui apagava por variant_id em loop e
                    // corria contra o re-split do brinde.

                    // Executar scripts inline que foram inseridos via innerHTML
                    cartSidebar.executeInlineScripts(cartDropdown);

                    // Aguardar proximo frame para garantir que os custom elements sejam conectados
                    requestAnimationFrame(() => {
                        cartSidebar.dispatchChangeForShippingMessage();
                    });
                })
                .catch(error => {
                    const halo = getHalo();
                    try {
                        const errorData = JSON.parse(error.responseText || '{}');
                        if (halo.showWarning) {
                            halo.showWarning(errorData.description || 'Error loading cart');
                        }
                    } catch (e) {
                        if (halo.showWarning) {
                            halo.showWarning('Error loading cart');
                        }
                    }
                })
                .finally(() => {
                    document.querySelectorAll('[data-cart-count]').forEach(el => {
                        el.textContent = cart.item_count;
                    });
                    if (cart.item_count >= 100) {
                        const cartCountBubble = document.querySelector('.cart-count-bubble [data-cart-count]');
                        if (cartCountBubble) cartCountBubble.textContent = window.cartStrings.item_99;
                    }
                    if (cart.item_count == 1) {
                        document.querySelectorAll('[data-cart-text]').forEach(el => {
                            el.textContent = window.cartStrings.item;
                        });
                    } else {
                        document.querySelectorAll('[data-cart-text]').forEach(el => {
                            el.textContent = window.cartStrings.items;
                        });
                    }
                    cartSidebar.productCollectionCartSlider();
                    cartSidebar.updateGiftWrapper();
                    const halo = getHalo();
                    if (halo.checkNeedToConvertCurrency && halo.checkNeedToConvertCurrency()) {
                        const currencyEl = document.querySelector('#currencies .active');
                        const currencyCode = currencyEl ? currencyEl.getAttribute('data-currency') : null;
                        if (currencyCode) {
                            Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                        }
                    }
                    document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
                    if (document.body.classList.contains('cursor-fixed__show')) {
                        window.sharedFunctionsAnimation.onEnterButton();
                        window.sharedFunctionsAnimation.onLeaveButton();
                    }
                });
        },

        executeInlineScripts: function (container) {
            // Extrair e executar scripts inline que foram inseridos via innerHTML
            // Browsers bloqueiam execução automática de scripts inseridos via innerHTML
            const scripts = container.querySelectorAll('script');
            scripts.forEach(function(oldScript) {
                const newScript = document.createElement('script');

                // Copiar atributos do script original
                Array.from(oldScript.attributes).forEach(function(attr) {
                    newScript.setAttribute(attr.name, attr.value);
                });

                // Copiar conteúdo (texto interno)
                if (oldScript.textContent) {
                    newScript.textContent = oldScript.textContent;
                } else if (oldScript.innerHTML) {
                    newScript.innerHTML = oldScript.innerHTML;
                }

                // Adicionar ao body para executar
                document.body.appendChild(newScript);

                // Remover script original
                oldScript.remove();
            });
        },

        dispatchChangeForShippingMessage: function () {
            // Disparar evento nos custom elements de frete grátis
            document.querySelectorAll('free-shipping-component').forEach(component => {
                const changeEvent = new Event('change', { bubbles: true });
                component.dispatchEvent(changeEvent);
            });
            // Fallback: também disparar nos elementos com data-free-shipping-wrapper
            document.querySelectorAll('[data-free-shipping-wrapper]').forEach(freeShippingWrapper => {
                const changeEvent = new Event('change', { bubbles: true });
                freeShippingWrapper.dispatchEvent(changeEvent);
            });
        },

        updateGiftWrapper: function () {
            let debounce;
            const giftWrapping = document.querySelector('#gift-wrapping');
            if (giftWrapping) {
                giftWrapping.addEventListener('click', (event) => {
                    event.stopPropagation();
                    event.preventDefault();
                    const target = event.currentTarget;
                    clearTimeout(debounce);
                    debounce = setTimeout(() => {
                        const variantId = event.target.dataset.giftId;
                        Shopify.addItem(variantId, 1, target, () => {
                            Shopify.getCart((cart) => {
                                cartSidebar.updateSidebarCart(cart);
                            });
                        });
                    }, 250);
                });
            }

            const cartGiftWrapping = document.querySelector('#cart-gift-wrapping');
            if (cartGiftWrapping) {
                cartGiftWrapping.addEventListener('click', (event) => {
                    event.stopPropagation();
                    event.preventDefault();

                    const target = event.currentTarget;
                    const text = target.getAttribute('data-adding-text');
                    if (text) target.textContent = text;

                    clearTimeout(debounce);
                    debounce = setTimeout(() => {
                        const variantId = event.target.dataset.giftId;
                        Shopify.addItem(variantId, 1, target, () => {
                            Shopify.getCart((cart) => {
                                cartSidebar.updateCart(cart);
                            });
                        });
                    }, 250);
                });
            }
        },

        removeItemQuickCart: function () {
            document.addEventListener('click', (event) => {
                const target = event.target.closest('[data-cart-remove]');
                if (!target) return;

                event.preventDefault();
                event.stopPropagation();

                const productId = target.getAttribute('data-cart-remove-id');
                const cartGiftWrapping = document.querySelector('#cart-gift-wrapping');
                const text = cartGiftWrapping ? cartGiftWrapping.getAttribute('data-add-text') : null;
                const productLine = target.dataset.line || target.getAttribute('data-line');
                const index = target.dataset.index || target.getAttribute('data-index');

                if (cartGiftWrapping && text) cartGiftWrapping.textContent = text;

                Shopify.removeItem(productLine, index, (cart) => {
                    if (document.body.classList.contains('template-cart')) {
                        cartSidebar.updateCart(cart);
                    } else if (document.body.classList.contains('cart-modal-show')) {
                        // halo.updateDropdownCart(cart);
                    } else if (document.body.classList.contains('cart-sidebar-show')) {
                        cartSidebar.updateSidebarCart(cart);
                    }
                });
            });
        },

        updateCart: function (cart) {
            if (cart && Object.keys(cart).length > 0) {
                const mainCartItems = document.querySelector('#main-cart-items');
                const sectionId = mainCartItems ? (mainCartItems.dataset.id || mainCartItems.getAttribute('data-id')) : null;
                const cartEl = document.querySelector('[data-cart]');
                if (!cartEl) return;

                const cartContent = cartEl.querySelector('[data-cart-content]');
                const cartTotals = cartEl.querySelector('[data-cart-total]');
                const cartLoading = '<div class="loading-overlay loading-overlay--custom">\
                        <div class="loading-overlay__spinner">\
                            <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">\
                                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>\
                            </svg>\
                        </div>\
                    </div>';
                const loadingClass = 'is-loading';

                cartEl.classList.add(loadingClass);
                cartEl.insertAdjacentHTML('afterbegin', cartLoading);

                fetch(`/cart?section_id=${sectionId}`, {
                    method: 'GET',
                    cache: 'no-store'
                })
                .then(response => response.text())
                .then(data => {
                    var jsPreventedData = data.replaceAll('cart-coupon-discount', 'div');
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(jsPreventedData, 'text/html');
                    const response = doc;

                    cartEl.classList.remove(loadingClass);
                    const loadingOverlay = cartEl.querySelector('.loading-overlay');
                    if (loadingOverlay) loadingOverlay.remove();

                    if (cart.item_count > 0) {
                        const contentCartEl = response.querySelector('[data-cart-content] .cart');
                        const subTotalEl = response.querySelector('[data-cart-total] .cart-total-subtotal');
                        const grandTotalEl = response.querySelector('[data-cart-total] .cart-total-grandtotal');
                        const savingsEl = response.querySelector('[data-cart-total] .cart-total-savings');

                        const contentCart = contentCartEl ? contentCartEl.innerHTML : '';
                        const subTotal = subTotalEl ? subTotalEl.innerHTML : '';
                        const grandTotal = grandTotalEl ? grandTotalEl.innerHTML : '';
                        const savings = savingsEl ? savingsEl.innerHTML : '';

                        const cartContentCart = cartContent ? cartContent.querySelector('.cart') : null;
                        const cartTotalsSubtotal = cartTotals ? cartTotals.querySelector('.cart-total-subtotal') : null;
                        const cartTotalsGrandtotal = cartTotals ? cartTotals.querySelector('.cart-total-grandtotal') : null;
                        const cartTotalsSavings = cartTotals ? cartTotals.querySelector('.cart-total-savings') : null;

                        if (cartContentCart) cartContentCart.innerHTML = contentCart;
                        if (cartTotalsSubtotal) cartTotalsSubtotal.innerHTML = subTotal;
                        if (cartTotalsGrandtotal) cartTotalsGrandtotal.innerHTML = grandTotal;
                        if (cartTotalsSavings) cartTotalsSavings.innerHTML = savings;

                        const calculatorShipping = response.querySelector('.haloCalculatorShipping');
                        if (calculatorShipping) {
                            const existingCalculator = cartEl.querySelector('.haloCalculatorShipping');
                            if (existingCalculator) {
                                existingCalculator.replaceWith(calculatorShipping.cloneNode(true));
                            }
                        }
                    } else {
                        const contentCartEl = response.querySelector('#main-cart-items');
                        const headerCartEl = response.querySelector('.page-header');
                        const cartCountdownEl = response.querySelector('.cart-countdown');

                        const contentCart = contentCartEl ? contentCartEl.innerHTML : '';
                        const headerCart = headerCartEl ? headerCartEl.innerHTML : '';
                        const cartCountdownText1 = cartCountdownEl ? (cartCountdownEl.dataset.coundownTextEmpty1 || cartCountdownEl.getAttribute('data-coundown-text-empty-1')) : '';
                        const cartCountdownText2 = cartCountdownEl ? (cartCountdownEl.dataset.coundownTextEmpty2 || cartCountdownEl.getAttribute('data-coundown-text-empty-2')) : '';
                        const cartCountdownProductUrl = cartCountdownEl ? (cartCountdownEl.dataset.coundownPrdEmptyUrl || cartCountdownEl.getAttribute('data-coundown-prd-empty-url')) : '';
                        const cartCountdownProductTitle = cartCountdownEl ? (cartCountdownEl.dataset.coundownPrdEmptyTitle || cartCountdownEl.getAttribute('data-coundown-prd-empty-title')) : '';
                        const cartCountdownHtml = cartCountdownText1 + ' <a href="' + cartCountdownProductUrl + '" class="cart-countdown-product link-effect p-relative"><span class="text">' + cartCountdownProductTitle + '</span></a> ' + cartCountdownText2;

                        const mainCartItemsEl = document.querySelector('#main-cart-items');
                        const pageHeaderEl = document.querySelector('.page-header');
                        const cartCountdownTextWrap = document.querySelector('.cart-countdown .text-wrap');

                        if (mainCartItemsEl) mainCartItemsEl.innerHTML = contentCart;
                        if (pageHeaderEl) pageHeaderEl.innerHTML = headerCart;
                        if (cartCountdownTextWrap) cartCountdownTextWrap.innerHTML = cartCountdownHtml;
                    }
                })
                .catch(error => {
                    const halo = getHalo();
                    try {
                        const errorData = JSON.parse(error.responseText || '{}');
                        if (halo.showWarning) {
                            halo.showWarning(errorData.description || 'Error updating cart');
                        }
                    } catch (e) {
                        if (halo.showWarning) {
                            halo.showWarning('Error updating cart');
                        }
                    }
                })
                .finally(() => {
                    document.querySelectorAll('[data-cart-count]').forEach(el => {
                        el.textContent = cart.item_count;
                    });
                    cartSidebar.dispatchChangeForShippingMessage();
                    const halo = getHalo();
                    if (halo.checkNeedToConvertCurrency && halo.checkNeedToConvertCurrency()) {
                        const currencyEl = document.querySelector('#currencies .active');
                        const currencyCode = currencyEl ? currencyEl.getAttribute('data-currency') : null;
                        if (currencyCode) {
                            Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                        }
                    }
                    if (document.body.classList.contains('template-cart')) {
                            const giftWrapping = document.getElementById('cart-gift-wrapping')
                            const isChecked = giftWrapping?.dataset.isChecked
                            const variantId = giftWrapping?.dataset.giftId
                            if (isChecked === 'true') {
                                const isAGift = document.querySelector('#is-a-gift');
                                if (isAGift) isAGift.style.display = 'none';
                                const giftCardRemoveButton = document.querySelector(`[data-cart-remove-id="${variantId}"]`)
                                const giftCardQuantityInput = document.querySelector(`[data-cart-quantity-id="${variantId}"]`)

                                giftCardRemoveButton?.addEventListener('click', () => {
                                    giftWrapping.dataset.isChecked = 'false'
                                })

                                giftCardQuantityInput?.addEventListener('change', (e) => {
                                    const value = Number(e.target.value)
                                    if (value <= 0) {
                                        giftWrapping.dataset.isChecked = 'false'
                                    }
                                })
                            } else {
                                const isAGift = document.getElementById('is-a-gift');
                                if (isAGift) isAGift.style.display = '';
                            }
                            if (cart.item_count >= 100) {
                                const cartCountBubble = document.querySelector('.cart-count-bubble [data-cart-count]');
                                if (cartCountBubble) cartCountBubble.textContent = window.cartStrings.item_99;
                            }
                    }

                    document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
                });
            }
        },

        updateQuantityItemQuickCart: function () {
            // Prevenir mudanças inválidas antes de acontecerem
            document.addEventListener('input', (event) => {
                const target = event.target;
                if (!target.hasAttribute('data-cart-quantity')) return;

                var quantity = parseInt(target.value) || 1;

                // Se quantidade for menor que 1, corrigir imediatamente
                if (quantity < 1) {
                    target.value = 1;
                }
            });

            document.addEventListener('change', (event) => {
                const target = event.target;
                if (!target.hasAttribute('data-cart-quantity')) return;

                event.preventDefault();
                event.stopPropagation();

                var productId = target.getAttribute('data-cart-quantity-id'),
                    productLine = target.dataset.line,
                    quantity = parseInt(target.value),
                    stock = parseInt(target.dataset.inventoryQuantity || 0),
                    index = target.dataset.index;
                let enoughInStock = true;

                const quickOrderList = target.closest('.quick-order-list__contents');
                if (quickOrderList) return;

                // Garantir que quantidade nunca seja menor que 1
                if (quantity < 1) {
                    quantity = 1;
                    target.value = 1;

                    // Atualizar estado dos botões após correção
                    var container = target.closest('.previewCartItem-qty, cart-update-quantity');
                    if (container) {
                        const minusBtn = container.querySelector('.btn-quantity.minus');
                        const plusBtn = container.querySelector('.btn-quantity.plus');

                        if (minusBtn) {
                            minusBtn.disabled = true;
                        }
                        if (plusBtn) {
                            plusBtn.disabled = false;
                        }
                    }
                }

                if (stock < quantity && stock > 0) {
                    const cartUpdateQuantity = target.closest('cart-update-quantity');
                    if (cartUpdateQuantity) {
                        var arrayInVarName = `cart_selling_array_${cartUpdateQuantity.dataset.product}`,
                        itemInArray = window[arrayInVarName],
                            itemStatus = itemInArray[cartUpdateQuantity.dataset.variant];
                    if (itemStatus == 'deny') {
                        quantity = stock;
                        enoughInStock = false;
                        }
                    }
                }

                Shopify.changeItem(productLine, quantity, index, (cart) => {
                    if ($body.classList.contains('template-cart')) {
                        cartSidebar.updateCart(cart);
                    } else if ($body.classList.contains('cart-modal-show')) {
                        // halo.updateDropdownCart(cart);
                    } else if ($body.classList.contains('cart-sidebar-show')) {
                        cartSidebar.updateSidebarCart(cart);
                    }
                    const halo = getHalo();
                    if (!enoughInStock && halo.showWarning) {
                        halo.showWarning(`${window.cartStrings.addProductOutQuantity.replace('[maxQuantity]', quantity)}`)
                    }
                });
            });
        },

        editQuickCart: function () {
            let checkLoadEC = true;

            document.addEventListener('click', function(event) {
                const editCartBtn = event.target.closest('[data-open-edit-cart]');
                if (!editCartBtn) return;

                event.preventDefault();
                event.stopPropagation();

                var target = editCartBtn;
                var url = target.getAttribute('data-edit-cart-url');
                var itemId = target.getAttribute('data-edit-cart-id');
                var itemLine = target.getAttribute('data-line');
                var itemIndex = target.getAttribute('data-index');
                var quantity = target.getAttribute('data-edit-cart-quantity');
                var previewCartItem = target.closest('.previewCartItem');
                var option = previewCartItem ? previewCartItem.querySelector('previewCartItem-variant')?.textContent : '';

                const modal = document.querySelector('[data-edit-cart-popup]');
                const modalContent = modal ? modal.querySelector('.halo-popup-content') : null;
                if (!modalContent) return;

                if (checkLoadEC) {
                    checkLoadEC = false;
                    const $editCart = document.querySelector('.halo-edit-cart-popup');
                    const urlStyleEC = $editCart.dataset.urlStyleEditCart;
                    const urlScriptEC = $editCart.dataset.urlScriptEditCart;

                    const halo = getHalo();
                    if (halo.buildStyleSheet) halo.buildStyleSheet(urlStyleEC, $editCart);
                    if (halo.buildScript) halo.buildScript(urlScriptEC);
                }

                if ($body.classList.contains('template-cart')) {
                    // halo.showLoading();
                }

                fetch(url, {
                    method: 'GET',
                    cache: 'no-store'
                })
                .then(response => {
                    if (!response.ok) {
                        return response.json().then(err => {
                            throw new Error(err.description || 'Erro ao carregar');
                        });
                    }
                    return response.text();
                })
                .then(data => {
                    modalContent.innerHTML = data;
                    const templateCartEdit = modalContent.querySelector('[data-template-cart-edit]');
                    if (templateCartEdit) {
                        templateCartEdit.setAttribute('data-cart-update-id', itemId);
                        templateCartEdit.setAttribute('data-line', itemLine);
                        templateCartEdit.setAttribute('data-index', itemIndex);
                    }

                    const productItem = modalContent.querySelector('.product-edit-item');
                    if (productItem) {
                        const quantityInput = productItem.querySelector('input[name="quantity"]');
                        if (quantityInput) quantityInput.value = quantity;
                    }

                    // Complete handler
                    $body.classList.add('edit-cart-show');

                        if ($body.classList.contains('template-cart')) {
                            // halo.hideLoading();
                        }

                        const halo = getHalo();
                        if (halo.checkNeedToConvertCurrency && halo.checkNeedToConvertCurrency()) {
                            const currencyEl = document.querySelector('#currencies .active');
                            const currencyCode = currencyEl ? currencyEl.getAttribute('data-currency') : null;
                            if (currencyCode) {
                                Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                            }
                        }

                        if (document.body.classList.contains('cursor-fixed__show')) {
                            if (window.sharedFunctionsAnimation) {
                                window.sharedFunctionsAnimation.onEnterButton();
                                window.sharedFunctionsAnimation.onLeaveButton();
                            }
                        }
                })
                .catch(error => {
                    console.error('Erro ao carregar edição do carrinho:', error);
                    const halo = getHalo();
                    if (halo.showWarning) {
                        halo.showWarning(error.message || 'Erro ao carregar');
                    }
                    if ($body.classList.contains('template-cart')) {
                        // halo.hideLoading();
                    }
                });
            });

            document.addEventListener('click', function(event) {
                const closeBtn = event.target.closest('[data-close-edit-cart]');
                if (closeBtn) {
                event.preventDefault();
                event.stopPropagation();
                    $body.classList.remove('edit-cart-show');
                }
            });

            document.addEventListener('click', function(event) {
                if ($body.classList.contains('edit-cart-show')) {
                    const editCartPopup = event.target.closest('[data-edit-cart-popup]');
                    const openEditCart = event.target.closest('[data-open-edit-cart]');
                    if (!editCartPopup && !openEditCart) {
                        $body.classList.remove('edit-cart-show');
                    }
                }
            });

            cartSidebar.addMoreItemEditCart();
            cartSidebar.addAllItemCartEdit();
        },

        addMoreItemEditCart: function () {
            document.addEventListener('click', (event) => {
                const addMoreBtn = event.target.closest('[data-edit-cart-add-more]');
                if (!addMoreBtn) return;

                event.preventDefault();
                event.stopPropagation();

                var itemWrapper = document.querySelector('[data-template-cart-edit]');
                if (!itemWrapper) return;

                var currentItem = event.target.closest('.product-edit-item');
                if (!currentItem) return;

                var count = parseInt(itemWrapper.getAttribute('data-count') || '0'),
                    cloneProduct = currentItem.cloneNode(true);
                cloneProduct.classList.remove('product-edit-itemFirst');

                const cloneProductId = (cloneProduct.id || '') + count;
                cloneProduct.id = cloneProductId;

                cartSidebar.updateClonedProductAttributes(cloneProduct, count);

                currentItem.parentNode.insertBefore(cloneProduct, currentItem.nextSibling);

                count = count + 1;
                itemWrapper.setAttribute('data-count', count);

                if (document.body.classList.contains('cursor-fixed__show')) {
                    window.sharedFunctionsAnimation.onEnterButton();
                    window.sharedFunctionsAnimation.onLeaveButton();
                }
            });

            document.addEventListener('click', (event) => {
                const removeBtn = event.target.closest('[data-edit-cart-remove]');
                if (!removeBtn) return;

                event.preventDefault();
                event.stopPropagation();

                var currentItem = event.target.closest('.product-edit-item');
                if (currentItem) currentItem.remove();
            });
        },

        updateClonedProductAttributes: function (product, count) {
            const productEl = product instanceof Element ? product : (product && product[0] ? product[0] : product);
            if (!productEl) return;

            var form = productEl.querySelector('.shopify-product-form');
            if (!form) return;

            var formId = form.id,
                newFormId = formId + count;

            form.id = newFormId;

            productEl.querySelectorAll('.product-form__radio').forEach((formInput) => {
                var formLabel = formInput.nextElementSibling;
                if (!formLabel) return;

                var id = formLabel.getAttribute('for'),
                    newId = id + count,
                    formInputName = formInput.getAttribute('name');

                formLabel.setAttribute('for', newId);

                formInput.id = newId;
                formInput.setAttribute('name', formInputName + count);
            });
        },

        addAllItemCartEdit: function () {
            document.addEventListener('click', (event) => {
                const target = event.target.closest('#add-all-to-cart');
                if (!target) return;

                event.preventDefault();
                event.stopPropagation();

                var cartEdit = document.querySelector('[data-template-cart-edit]');
                if (!cartEdit) return;

                var product = cartEdit.querySelectorAll('.product-edit-item.isChecked'),
                    productId = cartEdit.getAttribute('data-cart-update-id'),
                    productLine = cartEdit.dataset.line,
                    index = cartEdit.dataset.index;

                if (product.length > 0) {
                    target.classList.add('is-loading');

                    Shopify.removeItem(productLine, index, (cart) => {
                        if (cart && Object.keys(cart).length > 0) {
                            var productHandleQueue = [];

                            product.forEach((element) => {
                                var variantIdInput = element.querySelector('input[name="id"]');
                                var qtyInput = element.querySelector('input[name="quantity"]');

                                if (!variantIdInput || !qtyInput) return;

                                var variantId = variantIdInput.value,
                                    qty = parseInt(qtyInput.value);

                                productHandleQueue.push(
                                    fetch(window.routes.root + '/cart/add.js', {
                                        method: 'POST',
                                        headers: {
                                            'Content-Type': 'application/x-www-form-urlencoded',
                                        },
                                        body: 'quantity=' + qty + '&id=' + variantId
                                    }).then(response => response.json())
                                );
                            });

                            if (productHandleQueue.length > 0) {
                                Promise.all(productHandleQueue).then(() => {
                                    setTimeout(function () {
                                        target.classList.remove('is-loading');
                                    }, 1000);

                                    Shopify.getCart((cart) => {
                                        $body.classList.remove('edit-cart-show');

                                        if ($body.classList.contains('template-cart')) {
                                            cartSidebar.updateCart(cart);
                                        } else if ($body.classList.contains('cart-modal-show')) {
                                            // halo.updateDropdownCart(cart);
                                        } else if ($body.classList.contains('cart-sidebar-show')) {
                                            cartSidebar.updateSidebarCart(cart);
                                        }
                                    });
                                });
                            }
                        }
                    });
                } else {
                    alert(window.variantStrings.addToCart_message);
                }
            });
        }
    };

    // Attach to halo object
    if (typeof window !== 'undefined') {
        if (!window.halo) {
            window.halo = {};
        }
        Object.assign(window.halo, cartSidebar);

        // Export updateSidebarCart to window.sharedFunctions (como no backup)
        if (!window.sharedFunctions) {
            window.sharedFunctions = {};
        }
        window.sharedFunctions.updateSidebarCart = cartSidebar.updateSidebarCart;
        window.sharedFunctions.updatePopupCart = cartSidebar.updatePopupCart;
    }

    // Auto-inicialização após theme.js carregar
    // Como cart-sidebar.js carrega DEPOIS de theme.js no HTML, quando este código executar,
    // o theme.js já terá definido as funções necessárias (halo.actionAddToCart, halo.showWarning, etc.)
    function initCartSidebarModule() {
        if (window.quick_cart && window.quick_cart.show) {
            cartSidebar.initQuickCart();
        }
    }

    // Executar quando DOM estiver pronto
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initCartSidebarModule);
    } else {
        initCartSidebarModule();
    }
})();

